// Shared projects data used across Portfolio page and Projects Carousel
import { FaGlobe, FaMobile, FaShoppingCart } from 'react-icons/fa';

export const projects = [
  {
    id: 1,
    title: "Sttrika E-Commerce",
    category: "ecommerce",
    description: "A comprehensive e-commerce platform for fashion and lifestyle products with modern design and secure payment integration. Built with React and Node.js for optimal performance.",
    shortDesc: "Fashion & Lifestyle E-commerce Platform",
    technologies: ["React", "Node.js", "MongoDB", "Stripe", "TailwindCSS"],
    image: "https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "https://sttrika.com",
    stats: { users: '5K+', orders: '1K+', rating: '4.9' },
    features: ['Product Catalog', 'Cart System', 'Payment Integration', 'Order Tracking'],
    color: 'from-pink-500 to-rose-500',
    // Additional fields for carousel
    icon: FaShoppingCart,
    accentColor: '#EC4899',
    bgGradient: 'from-pink-400 to-rose-500',
    tags: ["React", "Node.js", "MongoDB"],
  },
  {
    id: 2,
    title: "Goforcab Mobility",
    category: "mobile",
    description: "Complete mobility solution with Android, iOS apps, admin panel, and driver app for affordable cab services. Features real-time tracking and seamless booking.",
    shortDesc: "Complete Ride-Hailing Solution",
    technologies: ["React Native", "Flutter", "Node.js", "Firebase", "Google Maps"],
    image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "https://goforcab.com",
    stats: { rides: '10K+', drivers: '500+', rating: '4.8' },
    features: ['Real-time Tracking', 'Fare Calculator', 'Driver Management', 'Rating System'],
    color: 'from-blue-500 to-cyan-500',
    // Additional fields for carousel
    icon: FaMobile,
    accentColor: '#3B82F6',
    bgGradient: 'from-blue-400 to-cyan-500',
    tags: ["React Native", "Flutter", "Firebase"],
  },
  {
    id: 3,
    title: "HiiHive Platform",
    category: "web",
    description: "A student-first platform where collaboration, leadership, and learning thrive together. Built with Next.js and TypeScript for modern web standards.",
    shortDesc: "Student Collaboration Platform",
    technologies: ["Next.js", "TypeScript", "Prisma", "PostgreSQL", "TailwindCSS"],
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "https://hiihive.vercel.app",
    stats: { students: '2K+', groups: '100+', rating: '4.9' },
    features: ['Group Formation', 'Project Management', 'Communication Hub', 'Resource Sharing'],
    color: 'from-purple-500 to-indigo-500',
    // Additional fields for carousel
    icon: FaGlobe,
    accentColor: '#8B5CF6',
    bgGradient: 'from-purple-400 to-indigo-500',
    tags: ["Next.js", "TypeScript", "PostgreSQL"],
  },
  {
    id: 4,
    title: "HB Web E-commerce",
    category: "ecommerce",
    description: "Modern e-commerce solution with product customization, wishlist management, and inventory tracking. Designed for scalability and performance.",
    shortDesc: "Modern E-commerce Solution",
    technologies: ["Next.js", "React", "Node.js", "MongoDB", "Razorpay"],
    image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "https://hbweb.vercel.app",
    stats: { products: '500+', orders: '2K+', rating: '4.7' },
    features: ['Product Customization', 'Wishlist', 'Inventory System', 'Analytics'],
    color: 'from-green-500 to-emerald-500',
    // Additional fields for carousel
    icon: FaShoppingCart,
    accentColor: '#10B981',
    bgGradient: 'from-green-400 to-emerald-500',
    tags: ["Next.js", "React", "MongoDB"],
  },
  {
    id: 5,
    title: "Mohan G Enterprises",
    category: "web",
    description: "Professional website for organic fertilizers and marble handicrafts business with B2B focus. Clean design with excellent SEO performance.",
    shortDesc: "B2B Business Website",
    technologies: ["HTML5", "CSS3", "JavaScript", "Responsive Design", "SEO"],
    image: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "https://mohangenterprises.com",
    stats: { visitors: '3K+', inquiries: '200+', rating: '4.8' },
    features: ['Product Showcase', 'Contact Forms', 'SEO Optimized', 'Fast Loading'],
    color: 'from-yellow-500 to-orange-500',
    // Additional fields for carousel
    icon: FaGlobe,
    accentColor: '#F59E0B',
    bgGradient: 'from-yellow-400 to-orange-500',
    tags: ["HTML5", "CSS3", "JavaScript"],
  },
  {
    id: 6,
    title: "GenZConnect",
    category: "web",
    description: "Social networking platform designed for Gen Z users with focus on authentic connections. Real-time messaging and community features.",
    shortDesc: "Gen Z Social Network",
    technologies: ["React", "Node.js", "PostgreSQL", "WebSocket", "Redis"],
    image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "https://genzconnect.vercel.app",
    stats: { users: '1K+', posts: '5K+', rating: '4.6' },
    features: ['Real-time Chat', 'Feed Algorithm', 'User Profiles', 'Communities'],
    color: 'from-violet-500 to-purple-500',
    // Additional fields for carousel
    icon: FaGlobe,
    accentColor: '#7C3AED',
    bgGradient: 'from-violet-400 to-purple-500',
    tags: ["React", "Node.js", "WebSocket"],
  },
  {
    id: 7,
    title: "ExamBulletin",
    category: "web",
    description: "Your trusted source for Sarkari Result, Government Jobs, Online Form, Admit Card, and Answer Key updates. सरकारी रिजल्ट - A comprehensive platform for government exam notifications from official sources with zero spam.",
    shortDesc: "Government Exam Notification Portal",
    technologies: ["React", "Node.js", "MongoDB", "TailwindCSS", "SEO"],
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "https://exambulletin.com",
    stats: { forms: '5+', results: '5+', users: '100%' },
    features: ['Live Updates', 'Exam Results', 'Admit Cards', 'Official Sources'],
    color: 'from-teal-500 to-cyan-500',
    // Additional fields for carousel
    icon: FaGlobe,
    accentColor: '#14B8A6',
    bgGradient: 'from-teal-400 to-cyan-500',
    tags: ["React", "MongoDB", "SEO"],
  },
  {
    id: 8,
    title: "Freelysta",
    category: "web",
    description: "A revolutionary freelancing platform connecting talented professionals with businesses worldwide. Freelysta offers seamless project management, secure payments, and AI-powered matching to help freelancers and clients succeed together.",
    shortDesc: "Next-Gen Freelancing Platform",
    technologies: ["React", "Next.js", "Node.js", "PostgreSQL", "Stripe", "AI/ML"],
    image: "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "https://freelysta.com",
    stats: { freelancers: '1K+', projects: '500+', rating: '4.9' },
    features: ['AI Matching', 'Escrow Payments', 'Project Management', 'Real-time Chat'],
    color: 'from-indigo-500 to-purple-500',
    // Additional fields for carousel
    icon: FaGlobe,
    accentColor: '#6366F1',
    bgGradient: 'from-indigo-400 to-purple-500',
    tags: ["React", "Next.js", "AI/ML"],
  },
];

export const categories = [
  { id: 'all', name: 'All Projects', icon: '🎯' },
  { id: 'web', name: 'Web Development', icon: '🌐' },
  { id: 'mobile', name: 'Mobile Apps', icon: '📱' },
  { id: 'ecommerce', name: 'E-Commerce', icon: '🛒' },
];

export default projects;
